import { IconButton, IconButtonProps, useBreakpointValue } from "@chakra-ui/react";

import { InfoIcon } from "@/components/shared/ReleaseIcons";
import { useRightDrawer } from "@/providers/useDrawers";

function RightDrawerHeaderControl({ ...props }: Partial<IconButtonProps>) {
  const { onOpen: onOpenRight } = useRightDrawer();
  if (!useBreakpointValue({ base: true, xl: false })) return null;

  return (
    <IconButton
      aria-label="help"
      colorScheme="niagara"
      icon={<InfoIcon />}
      size="lg"
      variant="lowlight"
      onClick={onOpenRight}
      {...props}
    />
  );
}

export default RightDrawerHeaderControl;
